<div class="dialog-header">
    <h2 mat-dialog-title>Bill Search</h2>
    <button mat-icon-button mat-dialog-close class="close-button" tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <form [formGroup]="searchForm" (ngSubmit)="search()" novalidate>
        <mat-form-field class="session-select" appearance="outline">
            <mat-label>Session</mat-label>
            <mat-select id="session" formControlName="session">
                <mat-option [value]="''">All Sessions</mat-option>
                <mat-option
                    *ngFor="let session of sessions"
                    [value]="session.name"
                    >{{ session.display }}</mat-option
                >
            </mat-select>
        </mat-form-field>
        <mat-form-field class="search-text" appearance="outline">
            <mat-label for="value">Bill Search</mat-label>
            <input
                #searchInput
                name="value"
                matInput
                placeholder="Bill Search"
                formControlName="text"
                (keyup.enter)="search()"
                autofocus
            />
            <button
                mat-icon-button
                matSuffix
                color="primary"
                type="submit"
                [disabled]="searchForm.invalid"
            >
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>
    </form>

    <div class="results-container">
        <mat-progress-bar
            *ngIf="isLoading"
            mode="indeterminate"
        ></mat-progress-bar>

        <mat-nav-list>
            <mat-list-item *ngFor="let item of results">
                <a
                    matListItemTitle
                    mat-dialog-close
                    [routerLink]="['/bills', item.billId]"
                    [attr.aria-label]="
                        'View bill ' +
                        item.measure +
                        ' from ' +
                        item.sessionYear +
                        ' session: ' +
                        item.subject
                    "
                >
                    <strong>({{ item.sessionYear }}) {{ item.measure }}</strong>
                </a>
                <span matListItemLine
                    >{{ item.subject }} {{ item.primaryAuthor }}</span
                >
            </mat-list-item>
            <mat-list-item *ngIf="results.length == 0">
                <span>No Bills found</span>
            </mat-list-item>
        </mat-nav-list>
    </div>
</mat-dialog-content>
